namespace $ {
	
	const { rem } = $mol_style_unit
	
	$mol_style_define( $hyoo_meta_rights, {
		
		flex: {
			basis: rem(20),
			grow: 0,
		},
		
		Editor_add: {
			Content: {
				flex: {
					wrap: 'wrap',
				},
			},
		},
		
	} )
	
}
